import BarleyIcon from '@old/assets/svg/siloreal/species/barley.svg';
import BeanIcon from '@old/assets/svg/siloreal/species/bean.svg';
import CornIcon from '@old/assets/svg/siloreal/species/corn.svg';
import RiceIcon from '@old/assets/svg/siloreal/species/rice.svg';
import SoyIcon from '@old/assets/svg/siloreal/species/soy.svg';
import WheatIcon from '@old/assets/svg/siloreal/species/wheat.svg';
import SunflowerIcon from '@old/assets/svg/siloreal/species/sunflower.svg';
import SorghumIcon from '@old/assets/svg/siloreal/species/sorghum.svg';
import SesameIcon from '@old/assets/svg/siloreal/species/sesame.svg';
import ChiaIcon from '@old/assets/svg/siloreal/species/chia.svg';
import RicePuitaIcon from '@old/assets/svg/siloreal/species/rice-puita.svg';
import MilhetoIcon from '@old/assets/svg/siloreal/species/milheto.svg';
import RyeIcon from '@old/assets/svg/siloreal/species/centeno.svg';
import ChickpeaIcon from '@old/assets/svg/siloreal/species/garbanzo.svg';
import Safflower from '@old/assets/svg/siloreal/species/cartamo.svg';
import Oatmeal from '@old/assets/svg/siloreal/species/avena.svg';
import Pea from '@old/assets/svg/siloreal/species/pea.svg';

type SpeciesImgsByIdProps = Record<number, string>;

export const SPECIES_IMG_BY_ID: SpeciesImgsByIdProps = {
  1: WheatIcon,
  2: SoyIcon,
  3: SunflowerIcon,
  4: SorghumIcon,
  5: RiceIcon,
  6: CornIcon,
  12: RicePuitaIcon,
  23: BarleyIcon,
  24: BeanIcon,
  25: SesameIcon,
  26: ChiaIcon,
  27: MilhetoIcon,
  28: RyeIcon,
  29: ChickpeaIcon,
  30: Safflower,
  31: Oatmeal,
  32: Pea,
};
